/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_SearchingInputs */

const en_filter_searching = /** @type {(inputs: Filter_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching descriptions`)
};

const de_filter_searching = /** @type {(inputs: Filter_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchsuche Beschreibungen`)
};

/**
* | output |
* | --- |
* | "Searching descriptions" |
*
* @param {Filter_SearchingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_searching = /** @type {((inputs?: Filter_SearchingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_SearchingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_searching(inputs)
	return en_filter_searching(inputs)
});